import React from "react";

const UpiICon = ({ fill = "#0D9488" }) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.8315 1.33331H5.16488C4.4285 1.33331 3.83154 1.93027 3.83154 2.66665V13.3333C3.83154 14.0697 4.4285 14.6666 5.16488 14.6666H11.8315C12.5679 14.6666 13.1649 14.0697 13.1649 13.3333V2.66665C13.1649 1.93027 12.5679 1.33331 11.8315 1.33331Z"
        stroke={fill}
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.49805 12H8.50471"
        stroke={fill}
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default UpiICon;
